<template>
  <div>
    <div class="modal" id="modal-notification" tabindex="-1" role="dialog" aria-labelledby="modal-notification" aria-hidden="true">
      <div class="modal-dialog modal-danger modal-dialog-centered modal-" role="document">
        <div class="modal-content bg-gradient-danger">
            <div class="modal-header">
              <h6 class="modal-title" id="modal-title-notification">Thông báo Đặt lịch hẹn </h6>
              <button type="button" class="close" @click="close_modal" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4">Đặt lịch hẹn thành công!!!</h4>
                    <p>Chúng tôi đã nhận được thông tin đặt lịch hẹn của bạn</p>
                    <div>Lịch hẹn của bạn và Cố vấn sẽ được sắp xếp trong thời gian sớm nhất</div>
                    <div>Cảm ơn bạn vì đã sử dụng dịch vụ của Moranow</div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-white" @click="close_modal">Đóng</button>
            </div>

        </div>
      </div>
  </div>
  </div>  

</template>
<script>
  export default{
    props: ['show_modal_booking_success'],
    methods: {
      close_modal: function () {
        this.show_modal_booking_success = false;
        this.$emit('close_modal', this.show_modal_booking_success)
      }
    }
  };
</script>



<style lang="scss" scoped>
  #modal-notification.modal{
    display: unset;
  }
</style>


// WEBPACK FOOTER //
// src/views/components/Modal/BookingSuccess.vue